import React, { useState } from 'react';
import { observer } from 'mobx-react';
import CMSButton from '../../../generic/inputs/CMSButton';
import CMSLink from '../../../generic/inputs/CMSLink';
import CMSIcons from '../../../generic/CMSIcons';
import OutlineButton from '../../../generic/inputs/OutlineButton/OutlineButton';
import SimpleModal from '../../../common/SimpleModal/SimpleModal';
import '../../../../scss/neurosales/common/cmsTopBar.scss';
import ToolsRedirector from '../../../common/ToolsRedirector';
const NeurosalesTopBar = observer(props => {
  const [openAdminMenu, setOpenAdminMenu] = useState(false);
  const [configurationMode, setConfigurationMode] = useState(false);
  const [cssModalWarning, setCssModalWarning] = useState(false);
  const logout = () => {
    props.logout().then(res => {
      if (res.data && res.data.logout === 'Ok') {
        window.location.href = props.baseUrl;
      }
    }).catch(err => console.error(err));
  };
  const handleCssButton = () => {
    setConfigurationMode(!configurationMode);
    const event = new Event('cssConfiguratorToggle'); // Dispatch the event.
    window.dispatchEvent(event);
  };
  const handleModalCssWarning = () => {
    if (configurationMode) {
      handleCssButton();
    } else {
      setCssModalWarning(true);
    }
  };
  const backButton = () => {
    const cancelButton = document.getElementById('settings-cancel-button');
    cancelButton.click();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cms-top-bar"
  }, /*#__PURE__*/React.createElement(CMSIcons, null), /*#__PURE__*/React.createElement(SimpleModal, {
    onSubmit: () => {
      setCssModalWarning(false);
      handleCssButton();
    },
    onCancel: () => setCssModalWarning(false),
    title: 'Attenzione',
    subtitle: 'Attraverso questo strumento verranno applicate delle modifiche grafiche alla sezione corrente. Queste modifiche possono essere effettuate solo da utenti esperti.',
    showModal: cssModalWarning
  }), /*#__PURE__*/React.createElement("div", {
    className: "cms-first-top-bar"
  }, /*#__PURE__*/React.createElement(ToolsRedirector, {
    className: "toolsRedirector-icon",
    products: props.products,
    enabledTools: props.enabledTools,
    loggedUser: props.loggedUser
  }), /*#__PURE__*/React.createElement("div", {
    className: "tecma-logo-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon tecma"
  })), /*#__PURE__*/React.createElement("div", {
    className: "emotions-name-container"
  }, "EMOTIONS"), /*#__PURE__*/React.createElement("div", {
    className: "emotions-open-configurator"
  }, !props.settingsPage && !props.firstStart && !props.selectPageTiles ? /*#__PURE__*/React.createElement(OutlineButton, {
    label: configurationMode ? 'Chiudi configuratore' : 'Apri configuratore',
    icon: 'green-pencil',
    white: false,
    onClick: handleModalCssWarning
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "controller-section"
  }, !props.settingsPage && !props.selectPageTiles && !props.firstStart ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "modify-cards"
  }, props.currentPage === 'HomePage' ? /*#__PURE__*/React.createElement(CMSLink, {
    underlined: true,
    onClick: () => props.setModifyPageTiles(true)
  }, /*#__PURE__*/React.createElement("p", null, "Modifica numero card")) : /*#__PURE__*/React.createElement(CMSLink, {
    underlined: true,
    onClick: () => {
      if (props.history) {
        props.history.push('/');
        setConfigurationMode(false);
        const event = new Event('cssConfiguratorClose'); // Dispatch the event.
        window.dispatchEvent(event);
      }
    }
  }, /*#__PURE__*/React.createElement("p", null, "Torna alla homepage"))), /*#__PURE__*/React.createElement("div", {
    className: "modify-page"
  }, /*#__PURE__*/React.createElement(CMSButton, {
    onClick: () => props.setCmsModal(true),
    className: "button-modify"
  }, props.currentPage !== 'NoComponent' ? 'Modifica' : 'Inizia')), /*#__PURE__*/React.createElement("div", {
    className: "save-configuration"
  }, /*#__PURE__*/React.createElement(OutlineButton, {
    onClick: () => {
      if (props.onSave) {
        props.onSave();
      }
    },
    label: 'Pubblica',
    className: "button-save"
  }))) : null, !props.settingsPage && !props.selectPageTiles && !props.firstStart ? /*#__PURE__*/React.createElement("div", {
    className: "settings-open-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon settings-white",
    onClick: () => {
      props.setSettingsPage(true);
    }
  })) : null, props.settingsPage && !props.selectPageTiles ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "modify-cards"
  }, /*#__PURE__*/React.createElement(CMSLink, {
    underlined: true,
    onClick: () => backButton()
  }, /*#__PURE__*/React.createElement("p", null, "Torna indietro")))) : null), props.loggedUser ? /*#__PURE__*/React.createElement("div", {
    className: `admin-container${!openAdminMenu ? ' close-menu' : ''}`,
    onClick: () => setOpenAdminMenu(!openAdminMenu)
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon large user-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "admin-name-container"
  }, props.loggedUser.firstName, " ", props.loggedUser.lastName), /*#__PURE__*/React.createElement("div", {
    className: `admin-dropdown-content${openAdminMenu ? ' open-menu' : ''}`
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => logout()
  }, "Logout"))) : ''));
});
export default NeurosalesTopBar;